import React from 'react';
import { MarketingCard } from '@tvg/fuse/marketing-card';
import { Typography } from '@tvg/fuse/typography';
import sendAnalyticsEventForTradeIn from 'utilities/tradeIn/tradeInUtilities';

import styles from './TradeIn.module.css';

interface TradeInProps {
  tradeInValue: number;
}

const sendAnalyticsEvent = () => {
  sendAnalyticsEventForTradeIn({ gaLabel: 'MTRTradeIn' });
};

export default function TradeIn(props: TradeInProps) {
  const { tradeInValue } = props;
  return (
    <MarketingCard
      className={styles.card}
      id="productTradeInMessage_link"
      header={
        <Typography className={styles.title} type="heading" size={{ xxs: '1', m: '1', l: '2' }} tag="h2">
          Claim up to £{tradeInValue}* when you trade-in your old device
        </Typography>
      }
      linkText="Find out more from our Trade-in partner, MTR"
      linkUrl="https://verytradein.mtr.co.uk"
      newWindow
      onClick={() => sendAnalyticsEvent()}
      dataTestId="trade-in-card"
      paragraphText="*Trade-in price is dependent on make, model and condition of the device you're trading in"
    />
  );
}
